import React, { useState } from 'react';
import { FaStar, FaRegStar } from 'react-icons/fa';
import { myFilesToggleFavorite } from '../../../../../services/CommonService';
import { toast } from 'react-toastify';

const FavoriteStar = ({ file, userId, onToggle, loading }) => {
  const [favLoading, setFavLoading] = useState(false);

  const handleToggle = async (e) => {
    e.stopPropagation();
    if (!userId) {
      toast.error('User ID is missing.');
      return;
    }
    try {
      setFavLoading(true);
      const payload = {
        file_id: file.id,
        user_id: userId
      };
      const response = await myFilesToggleFavorite(payload);
      if (response.data.message) {
        if (onToggle) onToggle(!file.is_favorite);
        toast.success(!file.is_favorite ? 'Added to favorites!' : 'Removed from favorites!');
      } else {
        toast.error(response.data.message || 'Failed to toggle favorite status');
      }
    } catch (err) {
      // console.error('Error toggling favorite:', err);
      toast.error(err.message || 'Failed to toggle favorite status');
    } finally {
      setFavLoading(false);
    }
  };

  return (
    <span
      className="favorite-star-top"
      style={{ position: 'absolute', top: 8, right: 10, zIndex: 2, cursor: 'pointer', color: file.is_favorite ? '#FFD700' : '#bbb' }}
      onClick={handleToggle}
      title={file.is_favorite ? 'Remove from favorites' : 'Add to favorites'}
    >
      {favLoading || loading ? (
        <span className="" style={{ fontSize: 16 }} />
      ) : file.is_favorite ? <FaStar /> : <FaRegStar />}
    </span>
  );
};

export default FavoriteStar; 